"use client";

import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

import { VideoReview } from "@/app/(marketing)/components/reviews/VideoReview";
import { Carousel } from "@/components/carousel/Carousel";
import { CarouselContent } from "@/components/carousel/CarouselContent";
import { CarouselItem } from "@/components/carousel/CarouselItem";
import { CarouselNext } from "@/components/carousel/CarouselNext";
import { CarouselPrevious } from "@/components/carousel/CarouselPrevious";
import { CarouselApi } from "@/components/carousel/types";
import { Heading2 } from "@/components/text/Heading2";
import { videoReviews } from "@/constants/videoReviews";
import { VideoReviewType } from "@/types/types";

export function Reviews({ className }: { className?: string }) {
  const [api, setApi] = useState<CarouselApi>();

  useEffect(() => {
    if (api === undefined) {
      return;
    }
  }, [api]);

  const chunkSize = 4;

  const videoReviews4on4 = videoReviews.reduce(
    (acc: VideoReviewType[][], currentValue, index) => {
      if (index % chunkSize === 0) {
        acc.push([]);
      } // Start a new chunk
      acc[acc.length - 1].push(currentValue); // Add the current value to the last chunk
      return acc;
    },
    []
  );

  return (
    <div className={twMerge("w-full overflow-hidden", className)}>
      <div className="mx-auto max-w-6xl px-10">
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <Heading2>Testimonials</Heading2>
        </div>
        <Carousel
          setApi={setApi}
          className="w-full"
          opts={{
            startIndex: 0,
          }}
        >
          <CarouselContent>
            {videoReviews4on4.map((videoReviews4) => (
              <CarouselItem key={videoReviews4[0].youtubeVideoId}>
                <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 md:gap-x-6 xl:gap-x-8">
                  {videoReviews4.map((videoReview) => (
                    <VideoReview
                      key={videoReview.youtubeVideoId}
                      videoReview={videoReview}
                    />
                  ))}
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>
    </div>
  );
}
